<template>
  <div>
    <div style="margin-top: 8px; margin-left: 8px">
      <el-button @click="search(1)"> 查询 </el-button>
      <el-button @click="modals"> 添加分类 </el-button>
    </div>
    <el-table
      style="margin-top: 8px; margin-left: 8px"
      max-height="600"
      :data="listData"
      border
    >
      <el-table-column label="名称" prop="name" />
      <el-table-column label="操作">
        <template slot-scope="data">
          <el-button size="mini" @click="view(data.row.id)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages" v-if="listData">
      <Page
        :total="searchForm.totalCount"
        :page-size="searchForm.pageSize"
        @on-change="search"
        show-total
      />
    </div>
    <el-dialog
      title="添加类别"
      :visible.sync="modal"
      width="60%"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="名称">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="项目">
          <el-tree
            :data="pindexList"
            :props="{ label: 'name', children: 'id' }"
            node-key="id"
            show-checkbox
            ref="tree"
            :default-checked-keys="defaultCheckedKeys"
          >
          </el-tree>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save">保存</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "pindexBelong",
  data() {
    return {
      listData: [],
      searchForm: {
        totalCount: 0,
        pageSize: 10,
        page: 1,
      },
      modal: false,
      form: {
        id: "",
        name: "",
        pindex_ids: [],
      },
      pindexList: [],
      defaultCheckedKeys: [],
    };
  },
  mounted() {
    this.pindex();
    this.search(1);
  },
  methods: {
    view(id) {
      this.$myhttp
        .post(
          "admin/ProjectType/view",
          { id },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.modal = true;
            this.form = backdata.data.data;
            this.defaultCheckedKeys =
              backdata.data.data.pindex_ids.length > 0
                ? backdata.data.data.pindex_ids
                : [];
            this.$refs.tree.setCheckedKeys(this.defaultCheckedKeys);
          } else {
            this.$message.error(backdata.data.msg);
          }
        });
    },
    del(id) {
      this.$myhttp
        .post(
          "admin/ProjectType/delete",
          { id },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
            this.search(1)
          } else {
            this.$message.error(backdata.data.msg);
          }
        });
    },
    search(page) {
      this.searchForm.page = page;
      this.$myhttp
        .post("admin/ProjectType/index", this.searchForm, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.listData = backdata.data.data;
            this.searchForm.totalCount = backdata.data.totalCount;
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    modals() {
      this.form = {
        id: "",
        name: "",
        pindex_ids: [],
      };
      this.modal = true;
    },
    handleClose() {
      this.modal = false;
    },
    save() {
      var pindex_ids = this.$refs.tree.getCheckedKeys();
      this.form.pindex_ids = pindex_ids;
      this.$myhttp
        .post("admin/ProjectType/save", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
            this.handleClose();
          } else {
            this.$message.error(backdata.data.msg);
          }
        });
    },
    pindex() {
      this.$myhttp
        .get("admin/common/pindex", {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.pindexList = backdata.data.data.map((item) => {
              return { name: item.name, id: item.id };
            });
          } else {
            this.$message.error(backdata.data.message);
          }
        });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Admin/Project/Belong.vue